import { render } from "./HistoricoView.vue?vue&type=template&id=0ecd10b5"
import script from "./HistoricoView.vue?vue&type=script&lang=js"
export * from "./HistoricoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__